export default function () {
    $(function () {
        const chartFigure = $(".hexaco-wheel-chart");
        const dimensions = chartFigure.data("dimensions");
        const facets = chartFigure.data("facets");

        const centerX = 364;
        const centerY = 364;

        const facetsAngle = 360 / facets.length;
        const dimensionsAngle = facetsAngle * 4;
        const initialStartAngle = 0 - facetsAngle * 2;
        let startAngle = initialStartAngle;
        let endAngle = initialStartAngle + facetsAngle;

        const dimensionsRadius = 364;
        const minFacetsRadius = 0;
        const maxFacetsRadius = 310;

        const minHexacoVal = 1;
        const maxHexacoVal = 5;
        const hexacoRangeVal = maxHexacoVal - minHexacoVal;

        let endDimension;
        let normEndDimension;
        let maxDimensionArc;
        let facetRadius;
        let normFacetRadius;

        function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
            const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

            return {
                x: centerX + (radius * Math.cos(angleInRadians)),
                y: centerY + (radius * Math.sin(angleInRadians))
            };
        }

        function describeArc(x, y, radius, startAngle, endAngle) {
            const start = polarToCartesian(x, y, radius, startAngle);
            const end = polarToCartesian(x, y, radius, endAngle);

            const arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
            return [
                "M", x, y,
                "L", start.x, start.y,
                "A", radius, radius, 0, arcSweep, 1, end.x, end.y, 'z'
            ].join(" ");
        }

        function calculateArc(mean, minArcValue, maxArcValue) {
            const percentage = ((mean - minHexacoVal) * 100) / hexacoRangeVal;
            return (percentage * (maxArcValue - minArcValue) / 100) + minArcValue;
        }

        // dimensions mean value is represented by the endAngle
        $.each(dimensions, function (key, value) {
            // handle of the special case "altruism" (key 1)
            maxDimensionArc = startAngle + ((key === 1) ? facetsAngle : dimensionsAngle);
            endDimension = calculateArc(value.mean, startAngle, maxDimensionArc);
            normEndDimension = calculateArc(value.normMean, startAngle, maxDimensionArc);

            $('.hexaco-chart-ring-segment' + key + ' .hexaco-chart-ring-segment-filling').attr('d', describeArc(centerX, centerY, dimensionsRadius, startAngle, endDimension));
            $('.hexaco-chart-ring-segment' + key + ' .hexaco-chart-ring-segment-graduation').attr('d', describeArc(centerX, centerY, dimensionsRadius, normEndDimension, normEndDimension));
            startAngle += (key === 1) ? facetsAngle : dimensionsAngle;
        });

        // facets mean value is represented by the radius
        startAngle = initialStartAngle;
        $.each(facets, function (key, value) {
            facetRadius = calculateArc(value.mean, minFacetsRadius, maxFacetsRadius);
            normFacetRadius = calculateArc(value.normMean, minFacetsRadius, maxFacetsRadius);

            $('.hexaco-chart-wedge' + key + ' .hexaco-chart-wedge-filling').attr('d', describeArc(centerX, centerY, facetRadius, startAngle, endAngle));
            $('.hexaco-chart-wedge' + key + ' .hexaco-chart-wedge-graduation').attr('d', describeArc(centerX, centerY, normFacetRadius, startAngle, endAngle));
            $('.hexaco-chart-wedge' + key + ' .hexaco-chart-wedge-text').text(value.label);

            startAngle += facetsAngle;
            endAngle += facetsAngle;
        });
});
}